import {
  maxAgentsTier,
  resolveAgentsTier,
  type AgentsTier,
} from "@hightouch/lib/llm/agents-tier";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useEntitlements } from "src/hooks/use-entitlement";
import { useOrganizationEntitlement } from "src/hooks/use-organization-entitlement";

export function useAgentsTier(): AgentsTier {
  const { dataAgents } = useFlags();
  // Two reads of the same entitlement, deliberately. The server's is the only
  // one that sees a staff grant from the Entitlement Center — grants live in
  // `entitlement_grants`, which the org entitlements jsonb knows nothing about.
  // The jsonb read is synchronous, so it keeps the hook answering correctly
  // before the query resolves rather than reporting "off" and bouncing users
  // out of the agent routes on first render.
  const hasOrgEntitlement = useOrganizationEntitlement("dataAgents");
  const { data } = useEntitlements(true);
  const hasDataAgents = hasOrgEntitlement || data.entitlements.dataAgents;

  // Neither source downgrades the other — matches the backend's OR semantics.
  // The entitlement confers the full tier; free only exists as an LD variant.
  return maxAgentsTier(
    resolveAgentsTier(dataAgents),
    hasDataAgents ? "full" : "off",
  );
}
